var exports = {
  "root": "x1cb7f6e3--0d1a3b--root",
  "phone": "x1cb7f6e3--0d1a3b--phone",
  "image": "x1cb7f6e3--0d1a3b--image",
  "title": "x1cb7f6e3--0d1a3b--title",
  "description": "x1cb7f6e3--0d1a3b--description",
};

module.exports = exports;
